module.exports = __webpack_public_path__ + "img/jch2.5b58bc19.jpg";